import React, {useState, useEffect, useMemo, useCallback} from 'react';
import moment from 'moment';

import Paper from '@material-ui/core/Paper';

import {withData} from '../../containers/DataContainer';
import useToggle from '../../hooks/useToggle';
import useDateInterval from '../../hooks/useDateInterval';
import EventsTable from '../../components/Tables/Events';
import useStyles from '../styles';

import EventDetails from './Details';

const Events = ({
  data,
  fetchEventsByDate,
  fetchDeliveriesByDate,
  fetchMeta,
  deleteEvent
}) => {

  const classes = useStyles();

  const [isBusy, setBusy] = useState(true);
  const [modalData, setModalData] = useState({});
  const [isModalOpen, toggleModal] = useToggle(false);
  const [startDate, setStartDate, endDate, setEndDate] = useDateInterval({
    startDate: moment().startOf('day'),
    endDate: moment().endOf('day')
  });

  useEffect(() => {
    const fetchData = async () => {
      setBusy(true);
      await Promise.all([
        fetchEventsByDate({
          startDate: '' + startDate.valueOf(),
          endDate: '' + Math.max(endDate.valueOf(), startDate.valueOf())
        }),
        // fetchDeliveriesByDate({
        //   startDate: '' + startDate.valueOf(),
        //   endDate: '' + endDate.valueOf()
        // }),
        // fetchMeta()
      ]);
      setBusy(false);
    };
    fetchData();
  }, [startDate, endDate, fetchEventsByDate]);

  const _deleteEvent = useCallback(() => {
    deleteEvent({_id: modalData._id, timestamp: modalData.timestamp});
    toggleModal();
  }, [modalData, deleteEvent, toggleModal]);

  const onRowClick = useCallback(({rowData}) => {
    setModalData(rowData);
    toggleModal();
  }, [toggleModal, setModalData]);

  const EventDetailsMemo = useMemo(() =>
    <EventDetails
      onDelete={_deleteEvent}
      onClose={toggleModal}
      isOpen={isModalOpen}
      data={modalData}
    />, [_deleteEvent, toggleModal, isModalOpen, modalData]);

  const EventTableMemo = useMemo(() =>
    <EventsTable
      data={data.events}
      {...{
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        onRowClick,
        isBusy
      }}
    />, [
      data.events,
      startDate,
      setStartDate,
      endDate,
      setEndDate,
      onRowClick,
      isBusy
    ]
  );

  return <>
    <Paper className={classes.paper}>
      {EventTableMemo}
    </Paper>
    {EventDetailsMemo}
  </>;
};

export default withData(Events);
